import WebServiceRequest from '../Api/WebServiceRequest'

class NotificationGetForWebRequest extends WebServiceRequest {
    constructor(context) {
        super(context)

        super.setMethod('GET')
        super.setTag(
            'Notifications/get-system-notification-by-userId-for-web',
        )
    }

    setParams(data) {
        super.setRequestParam({
            userId: data.userId,
            pageNumber: data.pageNumber || 1,
            count: data.count || 10,
        })
    }
}

class NotificationGetByUserIdRequest extends WebServiceRequest {
    constructor(context) {
        super(context)

        super.setMethod('GET')
        super.setTag(
            'Notifications/get-system-notification-by-userId',
        )
    }

    setParams(data) {
        const params = {
            userId: data.userId,
            PageNumber: data.PageNumber || data.pageNumber || 1,
            Count: data.Count || data.count || 10,
        }

        if (
            data.isFromSystem !== undefined
            && data.isFromSystem !== null
        ) {
            params.isFromSystem = data.isFromSystem
        }

        const searchItem = data.SearchItem !== undefined
            ? data.SearchItem
            : data.searchItem

        if (
            searchItem !== undefined
            && searchItem !== null
            && String(searchItem).trim() !== ''
        ) {
            params.SearchItem = String(searchItem).trim()
        }

        super.setRequestParam(params)
    }
}

class NotificationSendRequest extends WebServiceRequest {
    constructor(context) {
        super(context)

        super.setMethod('POST')
        super.setTag('Notifications/send-notification')
    }

    setPayload(data) {
        super.setRequestParamDataObj({
            senderId: data.senderId,
            subject: data.subject,
            description: data.description,
            allUsers: Boolean(data.allUsers),
            reciverIds: Array.isArray(data.reciverIds)
                ? data.reciverIds
                : [],
            notificationType: data.notificationType || 'SystemNotification',
            isFromSystem: data.isFromSystem !== undefined
                ? Boolean(data.isFromSystem)
                : true,
        })
    }
}

class NotificationMarkAsReadRequest extends WebServiceRequest {
    constructor(context) {
        super(context)

        super.setMethod('POST')
        super.setTag('Notifications/mark-as-read')
    }

    setPayload(data) {
        const userId = Number(data.userId)
        const notificationId = Number(data.notificationId)

        if (
            !Number.isFinite(userId)
            || userId <= 0
            || !Number.isFinite(notificationId)
            || notificationId <= 0
        ) {
            throw new TypeError(
                'userId and notificationId must be valid positive numbers.',
            )
        }

        super.setRequestParamDataObj({
            userId,
            notificationId,
        })
    }
}

class NotificationMarkAllAsReadRequest extends WebServiceRequest {
    constructor(context) {
        super(context)

        super.setMethod('POST')
        super.setTag('Notifications/mark-as-read-all')
    }

    setPayload(userId) {
        const normalizedUserId = Number(userId)

        if (
            !Number.isFinite(normalizedUserId)
            || normalizedUserId <= 0
        ) {
            throw new TypeError(
                'userId must be a valid positive number.',
            )
        }

        super.setRequestBody(normalizedUserId)
    }
}

export {
    NotificationGetForWebRequest,
    NotificationGetByUserIdRequest,
    NotificationSendRequest,
    NotificationMarkAsReadRequest,
    NotificationMarkAllAsReadRequest,
}
